export const RESET = 'BALANCE/RESET'
export const SET_SNAPSHOT = 'BALANCE/SET_SNAPSHOT'
export const SET_SUBSCRIBED = 'BALANCE/SET_SUBSCRIBED'
export const SET_UPDATE = 'BALANCE/SET_UPDATE'
export const STOP = 'BALANCE/STOP'
